<template>
<div>
  <div class="row justify-content-center">
                      <div class=" col-sm-12 grid-margin stretch-card">

                        <div class="card">
                          <div class="card-tile text-center p-2"><h2 class="">Active {{ users.length }} Clients</h2></div>
                          <div class="card-body text-center">
                            <ul class="nav nav-pills nav-fill">
  <li class="nav-item">
    <a class="nav-link active" aria-current="page" href="#">Airtime Purchasers ({{ users.length }})</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" href="#" v-on:click="routerToOtherPage('clients2')">Airtime Converters (0)</a>
  </li>
  <li class="nav-item">
    <a class="nav-link text-danger" href="#" v-on:click="routerToOtherPage('blacklist')">Blacklisted Clients(0)</a>
  </li>

</ul>
                            <div class="mb-3 row justify-content-center">
                              <div class="col-sm-6 float-right">
                              <input type="text" v-model="message.filterval"  v-on:keyup="filter()" class="form-control" placeholder="Type to start filtering">
                              </div>
                              <div class="col-sm-2">
                                    <download-excel
                                    :data="users"
                                    :fields="json_fields"
                                    name="All_Airtime_Purchasers.xls"
                                    >
                                        <a href="#"><i class="mdi mdi-file-excel fa-2x text-primary"></i></a>
                                     </download-excel>

                                </div>
                            </div>
                            <div class="table-responsive p-0">
                <table class="table align-items-center mb-0">
                  <thead>
                    <tr class="text-center">
                      <th class="text-uppercase  text-xxs font-weight-bolder">#</th>
                      <th class=" text-uppercase  text-xxs font-weight-bolder ">Phone</th>
                       <th class=" text-uppercase  text-xxs font-weight-bolder ">Cumulative Credit Bought</th>
                      <th class=" text-uppercase  text-xxs font-weight-bolder ">Last Transaction Date</th>

                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(data,index) in pageOfItems" :key="data.id" class="text-center">
                      <td>
                        {{index+1}}
                      </td>
                      <td >
                        {{data.phone}}
                      </td>
                       <td >
                       Ksh. {{formatPrice(data.amount)}}
                      </td>
                      <td >
                       {{filerDate(data.last_trans_date)}}
                      </td>

                    </tr>

                  </tbody>
                </table>
              </div>
              <div class="row mt-4 justify-content-center">
                    <div class="col-sm-12">
                        <jw-pagination :items="users"  @changePage="onChangePage" ></jw-pagination>
                    </div>
                </div>

                          </div>
                        </div>




                        </div>
                        </div>
</div>
</template>
<script>
    import moment from 'moment'
    export default {
        name: 'App',
        components: {

        },
        data(){
            return {
            users:[],
             users2:[],
            message:{id:'',lname:'',fname:'',email:'',phone:''},
             pageOfItems:[],
             json_fields: {
            "Phone": "phone",
            "Amount": "amount",
        }

            }
        },
        created(){
              this.Users();
        },
        methods: {
          ShowModal(fname,lname,email,phone,id){
            this.message.email=email;
            this.message.id=id;
            this.message.fname=fname
            this.message.lname=lname
            this.message.phone=phone
             $('#edit').modal('show');
          },
          onChangePage(pageOfItems) {
            this.pageOfItems = pageOfItems;
        },
        routerToOtherPage(val){
        this.$router.push({name: val});
      },
          updateUser(){
            $('#edit').modal('hide');
             this.$loading(true)
               let uri =`/api/auth/updateUser`;
                this.axios.post(uri,this.message, { headers: { Authorization: 'Bearer '+localStorage.getItem('token')}}).then((response) => {
                    this.$loading(false)
                   if(response.data.status){
                   this.$toast.open({message: response.data.message, type: 'success', position: 'top'});
                   this.Users();
                   }else{
                   this.$toast.open({message: response.data.message, type: 'error', position: 'top'});
                   }
                }).catch(error => {
                   this.$loading(false)
                    if (error.response.status === 401) {
                    this.$router.push({name: 'index'});
                    this.$toast.open({message: 'Please sign in!', type: 'error', position: 'top'});

                }else{
                    this.$toast.open({message: 'Something went wrong!.', type: 'error', position: 'top'});
                }

                });
          },
            Users(){
                this.$loading(true)
                let uri =`/api/auth/clientsC2B`;
                this.axios.get(uri, { headers: { Authorization: 'Bearer '+localStorage.getItem('token')}}).then((response) => {
                    this.$loading(false)
                    this.users=response.data;
                   this.users2=response.data;
                }).catch(error => {
                    this.$loading(false)
                    if (error.response.status === 401) {
                    this.$router.push({name: 'index'});
                    this.$toast.open({message: 'Please sign in!', type: 'error', position: 'top'});

                }else{
                    this.$toast.open({message: 'Something went wrong!.', type: 'error', position: 'top'});
                }

                });
            },

     filter(){
            let filterval=this.message.filterval;
            if(filterval==='' || filterval===null){
                this.users=this.users2;
            }else{
                let ads =  this.users2.filter(function(product) {
                    return product.phone.toLowerCase().includes(filterval.toLowerCase())
                });
                this.users=ads;
            }
        },
            formatPrice(value) {
                let val = (value/1).toFixed(2).replace('.', '.');
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            },
            filerDate(date){
                return moment(String(date)).format('MM/DD/YYYY HH:mm')
            }

        },
    }

</script>
